import axios from "axios";
import config from "../config";
import { message } from "antd";

export const urlAttachFileRc = () => {
    return config.rcAttachFileEndPoint;
    // return 'https://uat-vtrcapi.redcross.or.th/recruitment-api'
};

export const urlRc = () => {
    return config.recruitmentApiEndPoint;
    // return 'https://uat-vtrcapi.redcross.or.th/recruitment-api/api/v1'
};

const fetchClient = () => {
    const defaultOptions = {
        baseURL: urlRc(),
    };

    // Create instance
    const instance = axios.create(defaultOptions);

    instance.interceptors.request.use(function (_config) {
        const token = localStorage.getItem('token');
        _config.headers.Authorization = token ? `Bearer ${token}` : "";
        // _config.headers.secretKey = config.secretKey;
        return _config;
    });

    // Function to get new access token using refresh token
    const refreshToken = async () => {
        try {
            const refreshToken = localStorage.getItem('refreshToken');
            const response = await axios.post(`${urlRc()}/auth/refresh_token`, { refreshToken }, {
                headers: {
                    'x-refresh-token': 'true', // Add this header to identify refresh token requests
                },
            });
            console.log('refreshToken response =>', response)
            localStorage.setItem('token', response.data.token);
            localStorage.setItem('refreshToken', response.data.refreshToken);
            return response.data.token;
        } catch (error) {
            message.error('Session หมดอายุ');
            localStorage.clear();
            window.location.href = '/';
            return null;
        }
    };

    // Add an interceptor to handle token expiration or invalidation
    instance.interceptors.response.use(
        function (response) {
            // Return a successful response
            return response;
        },
        async function (error) {
            console.log('error response ==>', error)
            const originalRequest = error.config;

            // Check if the error status code indicates token expiration or invalidation
            if (error.response && (error.response.status === 401 || error.response.status === 403) && !originalRequest._retry) {
                originalRequest._retry = true;
                const newToken = await refreshToken();
                if (newToken) {
                    originalRequest.headers.Authorization = `Bearer ${newToken}`;
                    return axios(originalRequest);
                }
            }
            // Return an error
            return Promise.reject(error);
        }
    );

    return instance;
};

export default fetchClient();
